declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    env: any;
    decode: unknown;
    ReactNativeWebView?: {
      postMessage(msg: string): void;
    };
  }
}

type EnvType = {
  REACT_APP_API_KEY: string;
  REACT_APP_CORE_API_URI: string;
  REACT_APP_FULL_STORY_ID: string;
  REACT_APP_LOG_ROCKET_APP_ID: string;
  REACT_APP_MIXPANEL_CLINIC_WEB_TOKEN: string;
  REACT_APP_MIXPANEL_CLINIC_LEGACY_TOKEN: string;
  REACT_APP_MIXPANEL_PET_WEB_TOKEN: string;
  REACT_APP_SENTRY_ENVIRONMENT: string;
  REACT_APP_SENTRY_URL: string;
  REACT_APP_SUBSCRIPTIONS_URI: string;
  REACT_APP_TOKEN_ENDPOINT: string;
  REACT_APP_PRODUCTION: string;
  REACT_APP_SET_AUTH: string;
  REACT_APP_FIREBASE_API_KEY: string;
  REACT_APP_FIREBASE_AUTH_DOMAIN: string;
  REACT_APP_FIREBASE_DATABASE_URL: string;
  REACT_APP_GIT_TAG: string;
  REACT_APP_GIT_COMMIT: string;
};

export const env: EnvType = { ...process.env, ...window.env };
